// @flow

import React, { Component } from "react";

import { DatePicker } from "@components";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  options: Object,
  ...WidgetProps,
}>;

export default function SchemaFormDatePicker(props: Props) {
  return (
    <DatePicker
      {...props.options}
      enableTime={props?.schema?.format === "date-time"}
      onChange={props.onChange}
      disabled={props.disabled}
      readonly={props.readonly}
      value={props.value}
      className={["schema-form-widget-date-picker", props.className || ""].join(" ")}
    />
  );
}
